import axios from 'axios';
import BaseAPI from './base/base-api';

class AnalysisReportAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'analysisreport';
}

export default new AnalysisReportAPI();
